import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense, useMemo } from 'react'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { transformFilesToTree } from './workspaceFileTree'
import { WorkspaceFileTreeView } from './WorkspaceFileTreeView'
import { transformSharedFilesToTree } from '@/pages/Applications/ApplicationFileManagerPage/applicationFileTree'
import { ApplicationFileTreeView } from '@/pages/Applications/ApplicationFileManagerPage/ApplicationFileTreeView'
import { useListSharedFiles } from '@/pages/Applications/ApplicationFileManagerPage/useListSharedFiles'

export { transformFilesToTree } from './workspaceFileTree'
export type {
  FileItem,
  WorkspaceFileTreeFileNode,
  WorkspaceFileTreeFolderNode,
  WorkspaceFileTreeNode,
} from './workspaceFileTree'

export const WorkspaceFileManagerPage = () => {
  return (
    <>
      <WorkspacesBreadcrumbs title="Files" />
      <QueryErrorBoundary errorMessage="Failed to load workspace files">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceFilesPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceFilesPageContent() {
  const { workspaceId, app_key: appKey } = useCurrentWorkspace()

  const { getStorageApiGetFilesDetailsWorkspace } = useRestClient()
  const { data: files } = getStorageApiGetFilesDetailsWorkspace.useSuspenseQuery({ query: { workspaceId } })
  const { data: sharedData, refetch: refetchShared } = useListSharedFiles(appKey)

  const fileTree = useMemo(() => transformFilesToTree(files), [files])
  const sharedFileTree = useMemo(() => transformSharedFilesToTree(sharedData?.files ?? []), [sharedData])

  return (
    <TablePageContainer className="flex min-h-0 flex-col">
      <ScrollArea className="min-h-0 flex-1 pr-3">
        <WorkspaceFileTreeView className="py-2 pr-1" nodes={fileTree} />
        {sharedFileTree.length > 0 && (
          <div className="mt-4 border-t pt-4">
            <p className="mb-2 px-1 text-sm font-medium text-muted-foreground">Shared (cross-client)</p>
            <ApplicationFileTreeView
              className="pr-1"
              nodes={sharedFileTree}
              appKey={appKey}
              readOnly
              onRefresh={() => void refetchShared()}
            />
          </div>
        )}
      </ScrollArea>
    </TablePageContainer>
  )
}
